<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="80%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="80px">
      <el-form-item label="名称" prop="title">
        <el-input v-model="formData.title"></el-input>
      </el-form-item>
      <el-form-item label="域名" prop="domain">
        <el-input v-model="formData.domain"></el-input>
      </el-form-item>
      <el-form-item label="api域名" prop="domain_api">
        <el-input v-model="formData.domain_api"></el-input>
      </el-form-item>
      <el-form-item label="资源域名" prop="domain_res">
        <el-input v-model="formData.domain_res"></el-input>
      </el-form-item>
      <el-form-item label="文章路径" prop="article_path">
        <el-input v-model="formData.article_path"></el-input>
      </el-form-item>
      <el-form-item label="版权声明" prop="copyright">
        <my-quill :value="formData.copyright" @editorContent="editorContent"></my-quill>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import MyQuill from '../MyQuill.vue'
export default {
  name: 'handpick_source_add',
  props: [
    'visible', 'id'
  ],
  components: {
    'my-quill': MyQuill
  },
  data () {
    return {
      title: '添加来源',
      formData: {
        title: '',
        domain: '',
        domain_api: '',
        domain_res: '',
        article_path: '',
        copyright: ''
      },
      addFormRules: {
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        this.iconUrl = ''
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑来源'
        this.getSourceInfo(this.id)
      }
    },
    async getSourceInfo (id) {
      const res = await this.$http.get('/admin/handpick_source/info/' + id)
      if (res.code === 0) {
        this.formData = {
          title: res.data.title,
          domain: res.data.domain,
          domain_api: res.data.domain_api,
          domain_res: res.data.domain_res,
          article_path: res.data.article_path,
          copyright: res.data.copyright
        }
      }
    },
    editorContent (content) {
      this.formData.copyright = content
    }
  }
}
</script>

<style scoped>
</style>
